export const enum AccessArea {
  Administrator = 'Administrator',
  Project = 'ProjectsModule',
  Product = 'ProductSponsor',
  AssetManagement = 'AssetManagement',
  BulkPayment = 'BulkPayment',
  SystemAdministrator = 'UnifiiAdmin'
}

export const enum AccessRight {
  Executive = 'Executive',
  ViewOnly = 'ViewOnly',
  Basic = 'Basic',
  ViewAll = 'ViewAll',
}

export default function hasPermission(permissions: string[], area: AccessArea, ...rights: AccessRight[]) {
  // Converts permissions from array to object of { [AccessArea]: AccessRight[] } form.
  const permissionsMap = permissions.reduce(
    (accumulator, current) => {
      const [area, right] = current.split(':')

      accumulator[area] = accumulator[area] || []
      accumulator[area].push(right)

      return accumulator
    },
    {} as Record<string, string[]>
  )

  // System admin always has permission.
  if (AccessArea.SystemAdministrator in permissionsMap) {
    return true
  }

  // Just check if we have any permissions for the area if no rights are specified.
  if (rights.length < 1) {
    return area in permissionsMap
  }

  // Check exact access rights.
  for (const right of rights) {
    if (permissionsMap[area]?.includes(right)) {
      return true
    }
  }

  // Default to not having permission.
  return false
}